// extracted by mini-css-extract-plugin
export default {"fswLogoWrapper":"fswFooterLogo_fswLogoWrapper__GIu5w","fswLogoImg":"fswFooterLogo_fswLogoImg__nJXIF"};